export default "__VITE_ASSET__33a559d0__"